'use strict';

const Schemas = {};

Schemas.searchDataSchema = {
    '$schema': 'http://json-schema.org/draft-04/schema#',
    'id': 'http://www.odigeo.com/schemas/searchData#',
    'type': 'array',
    'title': 'root',
    'description': 'Search Data object',
    'minItems': 0,
    'uniqueItems': true,
    'additionalProperties': false,
    'items': {},
    'required': [
        'http://www.odigeo.com/schemas/searchData',
    ],
};

Schemas.searchData = {
    '$schema': 'http://json-schema.org/draft-04/schema#',
    'id': 'http://www.odigeo.com/schemas/searchData/search#',
    'type': 'object',
    'additionalProperties': true,
    'properties': {
        'searchId': {
            'type': 'integer',
        },
        'collectionMethod': {
            'type': 'integer',
        },
        'cabinClass': {
            'enum': ['BUSINESS', 'FIRST', 'TOURIST', 'PREMIUM_ECONOMY', 'ECONOMIC_DISCOUNTED', 'SHOW_ALL'],
        },
        'directFlightsOnly': {
            'type': 'boolean',
        },
        'trainSearch': {
            'type': 'boolean',
        },
        'numAdults': {
            'type': 'integer',
            'minimum': 1,
            'maximum': 9,
        },
        'numChildren': {
            'type': 'integer',
            'minimum': 0,
            'maximum': 5,
        },
        'numInfants': {
            'type': 'integer',
            'minimum': 0,
            'maximum': 3,
        },
        'cheapestItineraryPrice': {
            'type': 'number',
        },
        'cheapestItineraryPriceTimestamp': {
            'type': 'integer',
        },
        'resident': {
            'type': 'boolean',
        },
        'type': {
            'enum': ['oneWayTrip', 'roundTrip', 'multipleTrip'],
        },
        'internalSearch': {
            'type': 'boolean',
        },
        'flexibleDates': {
            'type': 'boolean',
        },
        'creationDate': {
            'type': 'integer',
        },
        'kid0Age': {
            'type': 'integer',
        },
        'kid1Age': {
            'type': 'integer',
        },
        'kid2Age': {
            'type': 'integer',
        },
        'kid3Age': {
            'type': 'integer',
        },
        'kid4Age': {
            'type': 'integer',
        },
        'kid5Age': {
            'type': 'integer',
        },
        'infant0Age': {
            'type': 'integer',
        },
        'infant1Age': {
            'type': 'integer',
        },
        'infant2Age': {
            'type': 'integer',
        },
        'infant3Age': {
            'type': 'integer',
        },
        'fromUserAccount': {
            'type': 'boolean',
        },
        'searchSegments': {
            'id': 'http://www.odigeo.com/schemas/searchData/searchSegments#',
            'type': 'array',
            'minItems': 1,
            'uniqueItems': true,
            'additionalProperties': false,
            'items': {
                'id': 'http://www.odigeo.com/schemas/searchData/searchSegments/segment#',
                'type': 'object',
                'title': 'Segment',
                'description': 'Segment of a trip',
                'additionalProperties': false,
                'properties': {
                    'dateStr': {
                        'type': 'string',
                        'pattern': '^(19[0-9]{2}|2[0-9]{3})-(0[1-9]|1[012])-([123]0|[012][1-9]|31)$',
                    },
                    'departure': {
                        'type': 'object',
                        'additionalProperties': true,
                        'properties': {
                            'city': {
                                'type': 'string',
                            },
                            'iata': {
                                'type': 'string',
                            },
                            'name': {
                                'type': 'string',
                            },
                            'geoNodeId': {
                                'type': 'integer',
                            },
                            'country': {
                                'type': 'string',
                            },
                            'countryCode': {
                                'type': 'string',
                            },
                            'text': {
                                'type': 'string',
                            },
                            'type': {
                                'enum': ['AIRPORT', 'IATA_CODE', 'CITY', 'BUS_STATION', 'TRAIN_STATION', 'COUNTRY'],
                            },
                        },
                        'required': [
                            'city',
                            'iata',
                            'name',
                            'geoNodeId',
                        ],
                    },
                    'destination': {
                        'type': 'object',
                        'additionalProperties': true,
                        'properties': {
                            'city': {
                                'type': 'string',
                            },
                            'iata': {
                                'type': 'string',
                            },
                            'name': {
                                'type': 'string',
                            },
                            'geoNodeId': {
                                'type': 'integer',
                            },
                            'country': {
                                'type': 'string',
                            },
                            'countryCode': {
                                'type': 'string',
                            },
                            'text': {
                                'type': 'string',
                            },
                            'type': {
                                'enum': ['AIRPORT', 'IATA_CODE', 'CITY', 'BUS_STATION', 'TRAIN_STATION', 'COUNTRY'],
                            },
                        },
                        'required': [
                            'city',
                            'iata',
                            'name',
                            'geoNodeId',
                        ],
                    },
                },
                'required': [
                    'dateStr',
                    'departure',
                    'destination',
                ],
            },
            'required': [
                'http://www.odigeo.com/schemas/searchData/searchSegments/segment',
            ],
        },
        'externalSelectionRequest': {
            'type': 'object',
            'additionalProperties': true,
            'properties': {
                'fareItineraryKey': {'type': 'string'},
                'segmentKeys': {
                    'id': 'http://www.odigeo.com/schemas/searchData/segmentKey#',
                    'type': 'array',
                    'minItems': 1,
                    'additionalProperties': false,
                    'items': {
                        'id': 'http://www.odigeo.com/schemas/searchData/segmentKey/string#',
                        'type': 'string',
                    },
                },
                'searchId': {'type': 'string'},
            },
        },
    },
    'required': [
        'cabinClass',
        'directFlightsOnly',
        'numAdults',
        'numChildren',
        'numInfants',
        'searchSegments',
        'type',
    ],
};

Schemas.travellersSchema = {
    '$schema': 'http://json-schema.org/draft-04/schema#',
    'id': 'http://www.odigeo.com/schemas/travellers#',
    'type': 'object',
    'additionalProperties': true,
    'properties': {
        'adults': {
            'type': 'object',
            'items': { },

        },
        'children': {
            'type': 'object',
            'items': { },
        },
        'infants': {
            'type': 'object',
            'items': { },
        },
        'defaultTraveler': {
            'anyOf': [
                {'type': 'null'},
                {'type': 'object'},
            ],
        },
    },
    'required': [
        'adults',
        'children',
        'infants',
    ],
};

Schemas.travellerAdults = {
    '$schema': 'http://json-schema.org/draft-04/schema#',
    'id': 'http://www.odigeo.com/schemas/travellers/adult',
    'type': 'object',
    'additionalProperties': true,
    'properties': {
        'travellerType': {
            'enum': ['ADULT'],
        },

        'travellerTitle': {
            'enum': ['MR', 'MRS', 'MS'],
        },

        'name': {
            'type': 'string',
        },

        'firstLastName': {
            'type': 'string',
        },
        'lastName': {
            'type': 'string',
        },

        'mail': {
            'type': 'string',
        },

        'country': {
            'type': 'string',
        },

        'phoneCode1': {
            'type': 'string',
        },
        'phoneNumber1': {
            'type': 'string',
        },

        'address': {
            'type': 'string',
        },
        'cityName': {
            'type': 'string',
        },
        'zipCode': {
            'type': 'string',
        },

        'meal': {
            'type': 'string',
        },

        'localityCodeOfResidence': {
            'type': 'string',
        },

        'localityNameOfResidence': {
            'type': 'string',
        },

        'identificationType': {
            'enum': ['PASSPORT', 'NIE', 'NIF', 'CIF', 'NATIONAL_ID_CARD', 'BIRTH_DATE'],
        },
        'identification': {
            'type': 'string',
        },
        'documents': {
            'id': 'http://www.odigeo.com/schemas/travellers/identification',
            'minItem': 1,
            'uniqueItems': true,
            'type': 'array',
            'additionalProperties': false,
            'items': {
                'id': 'http://www.odigeo.com/schemas/travellers/identification/document#',
                'type': 'object',
                'additionalProperties': false,
                'properties': {
                    'identificationType': {
                        'enum': ['PASSPORT', 'NIE', 'NIF', 'CIF', 'NATIONAL_ID_CARD', 'BIRTH_DATE'],
                    },
                    'identification': {
                        'type': 'string',
                    },
                },
                'required': [
                    'identificationType',
                    'identification',
                ],
            },
            'required': [
                'http://www.odigeo.com/schemas/travellers/identification/document',
            ],
        },
        'frequentFlyerCardCodes': {
            'id': 'http://www.odigeo.com/schemas/travellers/frequentFlyerCardCodes#',
            'minItem': 0,
            'uniqueItems': true,
            'type': 'array',
            'additionalProperties': false,
            'items': {
                'type': 'object',
                'additionalProperties': false,
                'properties': {
                    'carrierCode': {
                        'type': 'string',
                    },
                    'passengerCardNumber': {
                        'type': 'string',
                    },
                },
                'required': [
                    'carrierCode',
                    'passengerCardNumber',
                ],
            },
            'required': [
                'http://www.odigeo.com/schemas/travellers/frequentFlyerCardCodes#',
            ],
        },
    },
    'required': [
        'travellerType',
        'travellerTitle',
        'name',
        'firstLastName',
        // Commented the following fields because there are flights that don't require those fields,
        // then in those cases the passenger will be removed from LS
        /* ,
         "mail",
         "country",
         "phoneCode1",
         "phoneNumber1",
         "address",
         "cityName",
         "zipCode"*/
    ],
};

Schemas.travellerChildren = {
    '$schema': 'http://json-schema.org/draft-04/schema#',
    'id': 'http://www.odigeo.com/schemas/travellers/children',
    'type': 'object',
    'additionalProperties': true,
    'properties': {
        'travellerType': {
            'enum': ['CHILD', 'INFANT'],
        },

        'travellerTitle': {
            'enum': ['MR', 'MRS', 'MS'],
        },

        'name': {
            'type': 'string',
        },

        'firstLastName': {
            'type': 'string',
        },
        'dateOfBirth': {
            'type': 'string',
            'pattern': '^(19[0-9]{2}|2[0-9]{3})-(0[1-9]|1[012])-([123]0|[012][1-9]|31)$',
        },
    },
    'required': [
        'travellerType',
        'travellerTitle',
        'name',
        'firstLastName',
        'dateOfBirth',
    ],
};


module.exports = Schemas;
